/** @format */

import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

import { chain } from '@core/chain';

@Component({
	selector: 'my-account-components-simple-login-footer',
	templateUrl: './simple-login-footer.component.html',
	styleUrl: './simple-login-footer.component.scss',
	standalone: false
})
export class SimpleLoginFooterComponent implements AfterViewInit {
	public phoneNumber = chain.supportNumber;

	@ViewChild('footerCopyright')
	public footerCopyright: ElementRef;

	ngAfterViewInit() {
		this.buildAndAppendFooter();
	}

	private buildAndAppendFooter = () => {
		//copyright text
		const text = `© ${new Date().getFullYear()} ${chain.chainName}`;

		this.footerCopyright.nativeElement.textContent = text;
	};
}
